import api from '@/api'

const SET_SCHEDULES = 'SET_SCHEDULES'
const SET_CURRENT_SCHEDULE = 'SET_CURRENT_SCHEDULE'
const UNSET_CURRENT_SCHEDULE = 'UNSET_CURRENT_SCHEDULE'

export default {
  namespaced: true,

  state () {
    return {
      loaded: false,
      filters: {},
      schedules: [],
      currentSchedule: null
    }
  },

  getters: {
    loaded: (state) => state.loaded,
    schedules: (state) => state.schedules,
    currentSchedule: (state) => state.currentSchedule,
    filters: (state) => state.filters
  },

  mutations: {
    [SET_SCHEDULES] (state, data) {
      state.schedules = data
      state.loaded = true
    },

    [SET_CURRENT_SCHEDULE] (state, data) {
      state.currentSchedule = data
    },

    [UNSET_CURRENT_SCHEDULE] (state) {
      state.currentSchedule = null
    }
  },

  actions: {
    async loadSchedules (context, params = {}) {
      if (Object.keys(params).length) {
        context.state.loaded = false
      }
      for (const key in params) {
        context.state.filters[key] = params[key]
      }
      const filters = {}
      for (const key in context.state.filters) {
        filters[key] = context.state.filters[key]
      }
      const { data } = await api.animalfeed.schedules.list(filters)
      context.commit(SET_SCHEDULES, data)
    },

    async createSchedule (context, payload) {
      await api.animalfeed.schedules.create(payload)
      context.dispatch('loadSchedules')
    },

    setCurrentSchedule (context, data) {
      context.commit(SET_CURRENT_SCHEDULE, data)
    },

    unsetCurrentSchedule (context) {
      context.commit(UNSET_CURRENT_SCHEDULE)
    },

    async updateSchedule (context, { id, payload }) {
      await api.animalfeed.schedules.updateById(id, payload)
      context.dispatch('loadSchedules')
    },

    async deleteSchedule (context, { id }) {
      await api.animalfeed.schedules.deleteById(id)
      context.dispatch('loadSchedules')
    },

    loadSchedule (context, { id, payload }) {
      return api.animalfeed.schedules.load(id, payload)
    }
  }
}
